import { Button } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import {
  SubscriptionInfosFragment,
  useGetSubscriptionQuery,
  useValidateFundReceptionMutation,
} from '@blockpulse3/graphql/hooks';
import { useErrorToast, useSuccessToast } from '@blockpulse3/ui/commons';

type Props = {
  subscriptionId: SubscriptionInfosFragment['id'];
};

export function ValidatePayment({ subscriptionId }: Props): JSX.Element {
  const i18nSubscriberDetailsSidePanel = useTranslations('SubscriberDetailsSidePanel');

  const errorToast = useErrorToast();
  const successToast = useSuccessToast();

  const [validateFunds, { loading: loadingFunds }] = useValidateFundReceptionMutation();

  const { refetch, loading } = useGetSubscriptionQuery({
    variables: { subscriptionId },
  });

  const handleFundsValidation = (): void => {
    validateFunds({
      variables: {
        validateFundReceptionInput: {
          subscriptionId,
        },
      },
      onCompleted: () => {
        successToast({
          title: i18nSubscriberDetailsSidePanel('ValidationSteps.Payment.Toast.Success'),
        });
        refetch();
      },
      onError: (error) => {
        errorToast({
          title: i18nSubscriberDetailsSidePanel('ValidationSteps.Payment.Toast.Error'),
          description: error.message,
        });
      },
    });
  };

  return (
    <Button
      isDisabled={loadingFunds || loading}
      isLoading={loadingFunds || loading}
      size="sm"
      variant="secondary"
      onClick={handleFundsValidation}
    >
      {i18nSubscriberDetailsSidePanel('ValidationSteps.Payment.Validate')}
    </Button>
  );
}
